import { initBootstrapSelect } from '../../Shared/js/vendor/deferred/bootstrap-select';

(function () {
    'use strict';

    // HACK: async/await doesn't work with jQuery here for some reason
    wo$(() =>
        initBootstrapSelect().then(() => {
            var page = wo$('#share-product');
            if (!page.length) return;
            var data = WhistleOut.readLookupData(page);

            var controller = {
                init: function () {
                    controller.updateTransactUrl();

                    page.find('#embed-code, #share-url')
                        .off('click')
                        .click(function () {
                            WhistleOut.focusAndSelect(this, true);
                            WhistleOut.triggerPopoverNotification(this, data.resources.copied, 'bottom');
                        });

                    page.find('[data-shortcode-input]')
                        .off('click')
                        .click(function () {
                            WhistleOut.focusAndSelect(this, true);
                            WhistleOut.triggerPopoverNotification(this, data.resources.copied);
                        });

                    page.find('#transact-url')
                        .off('input')
                        .on('input', function () {
                            controller.updateTransactUrl();
                        });

                    page.on('show.bs.modal', function () {
                        var url = WhistleOut.replaceQueryString(data.embedInfoUrl, location.search);
                        wo$.ajax({
                            type: 'GET',
                            url: url,
                            async: true
                        })
                            .done(function (updatedData) {
                                data = updatedData;
                                controller.updateShareUrl();
                            })
                            .always(function () {
                                controller.updatePreview(true);
                            });
                        if (page.find('input#showWidgetCode').length) {
                            page.find('input#showWidgetCode').prop('checked', false);
                            page.find('input#embed-code').addClass('hidden');
                        }
                    });

                    page.find('input#showWidgetCode').change(function () {
                        if (this.checked) {
                            page.find('input#embed-code').removeClass('hidden');
                            page.find('input#embed-code').click();
                        } else {
                            page.find('input#embed-code').addClass('hidden');
                        }
                    });

                    WhistleOut.applySelectPicker(page.find('#widget-mode'));
                    page.find('#widget-mode').selectpicker('val', ['standard']);

                    page.find('#widget-mode')
                        .off('change', controller.updatePreview)
                        .on('change', function () {
                            controller.updatePreview(true);
                        });

                    wo$(window).on('message', function (event) {
                        if (
                            event.originalEvent.data &&
                            Object.prototype.hasOwnProperty.call(event.originalEvent.data, 'sentinel') &&
                            event.originalEvent.data.sentinel === 'whistleout-widget'
                        ) {
                            page.find('#embed-preview').height(event.originalEvent.data.height);
                        }
                    });
                },

                updateTransactUrl: function () {
                    var url = page.find('#transact-url').val();
                    var transactShortcodeInput = page.find('[data-original-shortcode]');
                    var originalShortcode = transactShortcodeInput.data('original-shortcode');
                    if (originalShortcode) {
                        var updatedShortcode = originalShortcode.replace('REPLACE_URL', url);
                        transactShortcodeInput.val(updatedShortcode);

                        var outputDiv = page.find('[data-original-output]');
                        var originalOutput = outputDiv.data('original-output');
                        var updatedOutput = originalOutput.replace('REPLACE_URL', url);
                        outputDiv.html(updatedOutput);

                        if (!outputDiv.data('bs.popover')) {
                            outputDiv.popover({
                                trigger: 'hover',
                                placement: 'top',
                                html: true,
                                content: function () {
                                    return page
                                        .find('[data-original-output]')
                                        .data('original-output')
                                        .replace('REPLACE_URL', page.find('#transact-url').val());
                                }
                            });
                        }
                    }
                },

                updatePreview: function (refreshWidget) {
                    var code;

                    var amp = false;
                    var compact = false;
                    var cta = false;
                    var ctaWide = false;

                    var selectedOptions = page.find('#widget-mode').selectpicker('val');
                    if (wo$.inArray('amp', selectedOptions) > -1) {
                        amp = true;
                    }
                    if (wo$.inArray('compact', selectedOptions) > -1) {
                        compact = true;
                    }
                    if (wo$.inArray('cta', selectedOptions) > -1) {
                        cta = true;
                    }
                    if (wo$.inArray('cta-wide', selectedOptions) > -1) {
                        ctaWide = true;
                    }

                    var query = '';
                    if (compact) {
                        query = WhistleOut.updateQueryStringParameter(query, 'layout', 'Compact');
                    } else if (cta) {
                        query = WhistleOut.updateQueryStringParameter(query, 'layout', 'CTA');
                    } else if (ctaWide) {
                        query = WhistleOut.updateQueryStringParameter(query, 'layout', 'CTA-Wide');
                    }

                    var embedAmpUrl = (data.embedAmpUrl + query).replace(/&/g, '&amp;');
                    var embedIFrameUrl = (data.embedIFrameUrl + '?' + query).replace(/&/g, '&amp;');
                    if (amp) {
                        code = data.embedAmpFormatString.replace('{ampurl}', embedAmpUrl);
                    } else {
                        var embedUrl = data.embedUrl + query;
                        if (data.encode) embedUrl = embedUrl.replace(/&/g, '&amp;');
                        code = data.embedFormatString
                            .replace('{url}', embedUrl)
                            .replace('{ampurl}', embedAmpUrl)
                            .replace('{iframeurl}', embedIFrameUrl);
                    }

                    page.find('#embed-code').val(code).css('background-color', 'rgba(255,255,0,.3)').animate(
                        {
                            backgroundColor: 'white'
                        },
                        2000
                    );

                    if (refreshWidget) {
                        var previewUrl = data.previewUrl;
                        if (compact) {
                            previewUrl = WhistleOut.updateQueryStringParameter(previewUrl, 'layout', 'Compact');
                        } else if (cta) {
                            previewUrl = WhistleOut.updateQueryStringParameter(previewUrl, 'layout', 'CTA');
                        } else if (ctaWide) {
                            previewUrl = WhistleOut.updateQueryStringParameter(previewUrl, 'layout', 'CTA-Wide');
                        }

                        page.find('#embed-preview').attr('src', previewUrl);
                    }
                },

                updateShareUrl: function () {
                    page.find('#share-url').val(data.shareUrl);
                }
            };

            controller.init();
        })
    );
})();
